import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-megapay-features',
  templateUrl: './megapay-features.component.html',
  styleUrls: ['./megapay-features.component.scss']
})
export class MegapayFeaturesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    console.log('MegapayFeaturesComponent initialized');
  }

}
